exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".span-label[data-v-451f6780]{margin-left:20px}.el-row[data-v-451f6780]{padding:5px}.main-bd .el-row[data-v-451f6780]{padding:5px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-451f6780","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/customer/Disruption.vue
// module id = 2199
// module chunks = 0